module.exports = __webpack_public_path__ + "img/zipped.e2277f46.webp";